module.exports = __webpack_public_path__ + "912ec66d7572ff821749319396470bde.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/vendor/font-awesome-4.7.0/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = 700
// module chunks = 49